import React, { useState, useEffect, useCallback, useMemo } from "react";
import ResponsiveDrawer from "../../component/sidebar/sidebar.component";
import { FontFamily } from "../../component/theme/fontFamily";
import { fontWeight } from "../../component/theme/fontWeight";
import { fontSize } from "../../component/theme/fontSize";
import {
  Box,
  CircularProgress,
  Grid,
  IconButton,
  Typography,
  List,
  ListItemButton,
  ListItemText,
  Divider,
  Paper,
  Chip,
  LinearProgress,
  Stack,
  Tooltip,
  Avatar,
} from "@mui/material";
import { ThemeColor } from "../../component/theme/color";
import dayjs from "dayjs";
import CustomButton from "../../component/button/button";
import OutlineCustomButton from "../../component/button/outlineButton";
import Settinglist from "../../Icon/Settinglist";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { GetScheduleSendMailUsing365Action, SetMailReplyPayload } from "../../Redux/action/EmailAction";
import { CustomPagination } from "../../component/datatable/CustomPagination";
import { ArrowBack, ArrowForward, LabelImportant, MarkEmailRead, MarkEmailUnread, Reply, ReplyAll } from "@mui/icons-material";
import { prepareEmailBody, resolveInlineImages } from "../../helper/helper";
import { fetchEmailBodyAndAttachments } from "../../Redux/service/MailService";

const EmaillistPage = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const debounce = (func, delay) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), delay);
    };
  };

  const [Emaillist, setEmaillist] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedMail, setSelectedMail] = useState(null); // 👈 Tracks currently open email preview
  const [mailBody, setMailBody] = useState(""); // 👈 Stores the body of the selected emai
  const [attachments, setAttachments] = useState([]); // 👈 Stores the attachments of the selected email
  const [bodyloading,setbodyLoading]=useState(false);
  const [mobileView, setMobileView] = useState("list");


  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
    limit: 50, // Increased default view capacity for index lists
    hasNextPage: false,
    hasPrevPage: false,
  });

  const [limit, setLimit] = useState(50);

  const EmaillistState = useSelector((state) => state.email?.email);

  // Fix Infinite loops from pagination object references
  useEffect(() => {
    if (EmaillistState) {
      const paginationData = EmaillistState?.pagination ?? EmaillistState?.data?.pagination;
      if (paginationData) {
        const currentPage = paginationData.page || 1;
        const estimatedTotalPages = paginationData.hasNextPage ? currentPage + 1 : currentPage;
        setPagination((prev) => ({
          ...prev,
          currentPage: currentPage,
          totalPages: estimatedTotalPages,
          totalCount: paginationData.totalCount ?? prev.totalCount,
          limit: paginationData.limit ?? prev.limit,
          hasNextPage: paginationData.hasNextPage ?? prev.hasNextPage,
          hasPrevPage: paginationData.hasPrevPage ?? prev.hasPrevPage,
        }));
        if (paginationData.limit) {
          setLimit(paginationData.limit);
        }
      }
    }
  }, [EmaillistState]);

  useEffect(() => {
    setLoading(true);
    dispatch(GetScheduleSendMailUsing365Action({ limit: pagination.limit, page: pagination.currentPage }));
  }, [dispatch, pagination.limit, pagination.currentPage]);

  useEffect(()=>{
    if (selectedMail){
      fetchBodyAndAttachments(selectedMail);
    }
  },[selectedMail])

  const handleEmailAction=async (action,selectedMail)=>{
    const response = await fetchEmailBodyAndAttachments(window.sessionStorage.getItem("ms_auth"), selectedMail.id);
    const payload={
      selectedEmail:{
        id: response.data.messageId,
        subject:selectedMail.subject,
        to: "",
        from: selectedMail.from
      },
      mailBody: response.data.body,
      attachments: response.data.attachments,
      action: action
    } 
    console.log(selectedMail.from)
    console.log(payload);

    if(action=="reply"){
      payload.selectedEmail.to = [selectedMail.from];
    }else if(action=="replyAll"){
      payload.selectedEmail.to = [selectedMail.from];
    }else{
      payload.selectedEmail.to = "";
    }
    dispatch(SetMailReplyPayload(payload))
    navigate("/CAE/Sendmail");
  }

  const fetchBodyAndAttachments = async (mail) => {
    if (!mail || !mail.id) return;
    try {
      setbodyLoading(true);
      const response = await fetchEmailBodyAndAttachments(window.sessionStorage.getItem("ms_auth"), mail.id);
      console.log("this is the response for the body and attachement", response);
      setMailBody(response.data.body || "");
      setAttachments(response.data.attachments || []);
      setbodyLoading(false);

    } catch (error) {
      console.error("Error fetching mail body and attachments:", error);
      setbodyLoading(false);
    }
  }

  useEffect(() => {
    const emailData = EmaillistState?.data?.data ?? EmaillistState?.data ?? EmaillistState;
    if (Array.isArray(emailData)) {
      const updatedData = emailData.map(({ messageId, ...rest }) => ({
        id: messageId,
        ...rest,  
      }));
      setEmaillist(updatedData);
      setLoading(false);
      // Auto-select first email if nothing is active
      if (updatedData.length > 0 && !selectedMail) {
        setSelectedMail(updatedData[0]);
      }
    } else if (EmaillistState !== undefined) {
      setEmaillist([]);
      setLoading(false);
    }
  }, [EmaillistState, selectedMail]);

  const handlePageChange = (page) => {
    setPagination((prev) => ({ ...prev, currentPage: page }));
  };

  const handleLimitChange = (newLimit) => {
    setLimit(newLimit);
    setPagination((prev) => ({ ...prev, currentPage: 1, limit: newLimit }));
  };

  return (
    <Box sx={{ p: 1, height: "calc(100vh - 120px)", display: "flex", flexDirection: "column" }}>
      {/* Top Header Row Panel */}
      {mobileView === "list" && (
        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item lg={8} md={7} xs={12}>
            <Typography fontFamily={FontFamily.Poppins} fontWeight={fontWeight.W600} fontSize={fontSize.h2.small}>
              Inbox
            </Typography>
          </Grid>
          <Grid item lg={4} md={5} xs={12}>
            <Box className="d-flex align-items-center w-100" sx={{ justifyContent: { sm: "space-between", xs: "space-between", lg: "end", md: "end" } }}>
              <div className="px-2">
                <CustomButton variant="contained" backgroundColor={ThemeColor.BLUE} color={ThemeColor.WHITE} onClick={() => navigate("/CAE/Sendmail")}>
                 Compose
                </CustomButton>
              </div>
            </Box>
          </Grid>
        </Grid>
      )}

      {/* Main Mail Split-Screen Window Layout */}
      <Box sx={{ flexGrow: 1, display: "flex", gap: 2, overflow: "hidden", minHeight: 400 }}>

        {/* Left Side: Email List Snippet Track Column */}
        <Paper variant="outlined" sx={{ width: "100%", display: mobileView === "list" ? "flex" : "none", flexDirection: "column", bgcolor: "background.paper", borderRadius: "16px", overflow: "hidden", border: "1px solid #e2e8f0", boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.02)" }}>
          {loading ? (
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", py: 8, flexGrow: 1 }}>
              <CircularProgress color="primary" />
              <Typography sx={{ mt: 2, color: ThemeColor.DARK, fontWeight: 600, fontSize: "0.9rem" }}>
                Syncing Office 365 Feed...
              </Typography>
            </Box>
          ) : Emaillist.length === 0 ? (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", flexGrow: 1 }}>
              <Typography color="textSecondary">No messages found.</Typography>
            </Box>
          ) : (
            <List sx={{ flexGrow: 1, overflowY: "auto", p: 0 }}>
              {Emaillist.map((mail) => {
                const isSelected = selectedMail?.id === mail.id;
                return (
                  <React.Fragment key={mail.id}>
                    <ListItemButton
                      onClick={() => {
                        setSelectedMail(mail);
                        setMobileView("details");
                      }}
                      selected={isSelected}
                      sx={{
                        p: 2,
                        alignItems: "flex-start",
                        flexDirection: "column",
                        borderLeft: isSelected ? `4px solid ${ThemeColor.PURPLE}` : "4px solid transparent",
                        bgcolor: isSelected ? "rgba(106, 27, 154, 0.06)" : "inherit",
                        "&:hover": { bgcolor: "rgba(0, 0, 0, 0.02)" },
                        transition: "all 0.2s ease"
                      }}
                    >
                      <Box sx={{ display: "flex", width: "100%", justifyContent: "space-between", mb: 0.5, alignItems: "center" }}>
                        <Typography variant="subtitle2" sx={{ fontWeight: mail.isRead ? 500 : 700, color: "text.primary", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "70%" }}>
                          {mail.from || "Unknown Sender"}
                        </Typography>
                        <Typography variant="caption" color="textSecondary">
                          {dayjs(mail.receivedDateTime).format("MMM DD, hh:mm A")}
                        </Typography>
                      </Box>

                      <Box sx={{ display: "flex", alignItems: "center", width: "100%", gap: 0.5, mb: 0.5 }}>
                        {mail.importance === "high" && <LabelImportant color="error" sx={{ fontSize: 16 }} />}
                        <Typography variant="body2" sx={{ fontWeight: mail.isRead ? 400 : 600, color: isSelected ? "primary.main" : "text.secondary", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", width: "100%" }}>
                          {mail.subject || "(No Subject)"}
                        </Typography>
                      </Box>
                    </ListItemButton>
                    <Divider />
                  </React.Fragment>
                );
              })}
            </List>
          )}

          {/* Pagination Nested Bottom Control Bar */}
          <Box sx={{ p: 1, borderTop: "1px solid #e0e0e0", bgcolor: "#f8f9fa" }}>
            <CustomPagination
              pagination={pagination}
              onPageChange={handlePageChange}
              limit={limit}
              onLimitChange={handleLimitChange}
            />
          </Box>
        </Paper>

        {/* Right Side: Document Reader Screen Panel */}
        <Paper variant="outlined" sx={{ flexGrow: 1, width: "100%", display: mobileView === "details" ? "flex" : "none", flexDirection: "column", bgcolor: "background.paper", borderRadius: "16px", overflow: "hidden", border: "1px solid #e2e8f0", boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.02)" }}>
          {selectedMail ? (
            <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
              {/* Active Item Metadata Header */}
              <Box sx={{ py: 1.5, px: 2, borderBottom: "1px solid #e2e8f0", bgcolor: "#f8fafc" }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                  <IconButton
                    onClick={() => setMobileView("list")}
                    sx={{ p: 0.5, color: "#64748b" }}
                  >
                    <ArrowBack sx={{ fontSize: 20 }} />
                  </IconButton>
                  <Typography variant="subtitle1" sx={{ fontFamily: FontFamily.Poppins, fontWeight: 600, color: "#0f172a", flexGrow: 1, fontSize: "14px", lineHeight: 1.2 }}>
                    {selectedMail.subject || "(No Subject)"}
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 1, flexWrap: "nowrap" }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0 }}>
                    <Avatar sx={{ bgcolor: "rgba(106, 27, 154, 0.08)", color: ThemeColor.PURPLE, fontWeight: 600, width: 32, height: 32, fontSize: "12px" }}>
                      {selectedMail.from ? selectedMail.from.charAt(0).toUpperCase() : "U"}
                    </Avatar>
                    <Box sx={{ minWidth: 0 }}>
                      <Typography variant="body2" sx={{ fontFamily: FontFamily.Poppins, fontWeight: 600, color: "#1e293b", fontSize: "12.5px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                        {selectedMail.from}
                      </Typography>
                      <Typography variant="caption" sx={{ fontFamily: FontFamily.Nunito, color: "#64748b", fontSize: "10.5px" }}>
                        {dayjs(selectedMail.receivedDateTime).format("MMM DD, YYYY [at] hh:mm A")}
                      </Typography>
                    </Box>
                  </Box>

                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexShrink: 0 }}>
                    {selectedMail.importance === "high" && (
                      <Chip label="High" color="error" size="small" variant="outlined" sx={{ borderRadius: "4px", fontSize: "10px", height: "18px", fontWeight: 600 }} />
                    )}

                    <Stack direction="row" spacing={0.25}>
                      <Tooltip title="Reply" arrow>
                        <IconButton
                          size="small"
                          onClick={() => handleEmailAction('reply', selectedMail)}
                          sx={{ p: 0.5, color: '#475569', '&:hover': { bgcolor: '#e2e8f0', color: '#2563eb' } }}
                        >
                          <Reply sx={{ fontSize: 18 }} />
                        </IconButton>
                      </Tooltip>

                      <Tooltip title="Reply All" arrow>
                        <IconButton
                          size="small"
                          onClick={() => handleEmailAction('replyAll', selectedMail)}
                          sx={{ p: 0.5, color: '#475569', '&:hover': { bgcolor: '#e2e8f0', color: '#2563eb' } }}
                        >
                          <ReplyAll sx={{ fontSize: 18 }} />
                        </IconButton>
                      </Tooltip>

                      <Tooltip title="Forward" arrow>
                        <IconButton
                          size="small"
                          onClick={() => handleEmailAction('forward', selectedMail)}
                          sx={{ p: 0.5, color: '#475569', '&:hover': { bgcolor: '#e2e8f0', color: '#2563eb' } }}
                        >
                          <ArrowForward sx={{ fontSize: 18 }} />
                        </IconButton>
                      </Tooltip>
                    </Stack>
                  </Box>
                </Box>
              </Box>

              {bodyloading?<Box sx={{flex:1,alignItems:"center",justifyContent:"center",textAlign:"center"}}><LinearProgress /></Box>:
                <Box sx={{ flexGrow: 1, p: 3, overflowY: "auto", bgcolor: "#ffffff" }}>
                  {mailBody ? (
                    <div
                      style={{ fontFamily: "inherit", fontSize: "0.95rem", lineHeight: 1.6 }}
                      dangerouslySetInnerHTML={{
                        __html: resolveInlineImages(mailBody, attachments)
                        // __html: prepareEmailBody(mailBody, attachments)
                      }}
                    />
                  ) : (
                    <Typography variant="body2" color="textSecondary" sx={{ fontStyle: "italic" }}>
                      This message has no body contents.
                    </Typography>
                  )}
                </Box>}
            </Box>
          ) : (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", flexDirection: "column", gap: 1 }}>
              <MarkEmailUnread color="disabled" sx={{ fontSize: 48 }} />
              <Typography color="textSecondary" variant="body2">
                Select an item from the feed column list to preview details.
              </Typography>
            </Box>
          )}
        </Paper>

      </Box>
    </Box>
  );
};

function Emaillist() {
  return (
    <div>
      <ResponsiveDrawer maincontent={<EmaillistPage />} />
    </div>
  );
}

export default Emaillist;